var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Base',{ref:"base",attrs:{"on-submit":(params) => _vm.api.template.create(params),"triger-prevent":_vm.trigerPrevent,"field-details-route":"field-details","templates-route":"templates","is-ticket":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }